export const QUESTIONNAIRE_PSYCHODIAGNOSTIKA_TYPE = 0;
export const QUESTIONNAIRE_PSYCHODIAGNOSTIKA_DEMO_TYPE = 1;
export const QUESTIONNAIRE_PRUZKUM_TYPE = 4;
export const QUESTIONNAIRE_PERFEED_TYPE = 6;
export const QUESTIONNAIRE_MANAGEMENT_TYPE = 7;
export const QUESTIONNAIRE_360_TYPE = 360;
